// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifications_container__1gl6P","notifications":"Notifications_notifications__23Jfl","textarea":"Notifications_textarea__27iIu","btn":"Notifications_btn__3HesG"};